export default function Topbar({ title, user }) {
  const isAdmin = user?.role === 'admin';
  const initials = (user?.email || 'U').split('@')[0].slice(0, 2).toUpperCase();
  return (
    <div className="topbar">
      <div className="topbar-title">{title}</div>
      <div className="topbar-right">
        <span className={`badge ${isAdmin ? 'badge-teal' : 'badge-blue'}`}>{user?.role || 'User'}</span>
        <div className="avatar">{initials}</div>
        <div>
          <div className="user-name">{user?.email}</div>
          <div className="user-role">{isAdmin ? 'Administrator' : 'Employee'}</div>
        </div>
      </div>
    </div>
  );
}
